import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '../node_modules/lightgallery/dist/css/lightgallery.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
